import React from 'react';

const Button = props => {
  let btnProps = Object.assign({}, props),
    classes = btnProps.className ? btnProps.className.split(" ") : [],
    color = btnProps.color;
  classes.push("r-btn")
  if (color)
    classes.push(`r-btn--${color}`)
  if (btnProps.square)
    classes.push("r-btn--no-radius")
  if (btnProps.rounded)
    classes.push("r-btn--rounded")
  return (
    <button {...btnProps} className={classes.join(" ")}>{btnProps.children}</button>
  )
}

export default Button;
